var _path, _g, _g2, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect5, _path16, _path17, _rect6, _path18, _g3, _path19, _rect7, _rect8, _rect9, _rect10, _rect11, _path20, _path21, _rect12, _rect13, _path22, _path23, _rect14, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 249,
    viewBox: "0 0 405 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.402 246.429C339.307 220.355 352.5 186.718 352.5 150C352.5 67.1573 285.343 0 202.5 0C119.657 0 52.5 67.1573 52.5 150C52.5 186.718 65.6931 220.355 87.5976 246.429H317.402Z",
    fill: "#24272E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.079 108.338C288.915 108.533 288.809 108.769 288.772 109.021L283.951 141.836C283.86 142.45 284.195 143.049 284.766 143.294L289.079 145.142C289.146 145.171 289.213 145.194 289.28 145.211C289.463 145.258 289.619 145.408 289.619 145.597V155.72C289.619 156.098 289.925 156.405 290.304 156.405C290.682 156.405 290.988 156.098 290.988 155.72V143.893C290.988 143.89 290.988 143.886 290.988 143.883L290.988 107.007C290.988 106.687 290.59 106.542 290.384 106.786L289.079 108.338Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.079 107.653C288.915 107.848 288.809 108.084 288.772 108.336L283.951 141.151C283.86 141.765 284.195 142.364 284.766 142.609L289.079 144.457C289.146 144.486 289.213 144.508 289.28 144.526C289.463 144.573 289.619 144.723 289.619 144.912V155.035C289.619 155.413 289.925 155.719 290.304 155.719C290.682 155.719 290.988 155.413 290.988 155.035V143.208C290.988 143.205 290.988 143.201 290.988 143.198L290.988 106.322C290.988 106.002 290.59 105.857 290.384 106.101L289.079 107.653Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.247 180.037C250.498 180.081 250.756 180.055 250.992 179.961L281.821 167.729C282.399 167.5 282.75 166.911 282.676 166.294L282.121 161.634C282.112 161.562 282.098 161.493 282.08 161.426C282.029 161.244 282.081 161.034 282.244 160.94L291.011 155.878C291.339 155.689 291.451 155.27 291.262 154.943C291.073 154.615 290.654 154.503 290.326 154.692L280.082 160.607C280.08 160.608 280.078 160.609 280.076 160.61L273.719 164.28L248.14 179.049C247.863 179.208 247.936 179.626 248.251 179.682L250.247 180.037Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.905 179.694C250.155 179.739 250.413 179.713 250.649 179.619L281.479 167.387C282.056 167.157 282.407 166.568 282.334 165.951L281.778 161.292C281.769 161.22 281.756 161.15 281.737 161.083C281.687 160.901 281.738 160.692 281.902 160.597L290.669 155.536C290.996 155.347 291.108 154.928 290.919 154.6C290.73 154.273 290.311 154.161 289.984 154.35L279.74 160.264C279.738 160.265 279.735 160.267 279.733 160.268L247.797 178.706C247.52 178.866 247.594 179.284 247.908 179.34L249.905 179.694Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.2 178.385C332.114 178.146 331.962 177.936 331.763 177.778L305.755 157.195C305.267 156.81 304.582 156.8 304.084 157.172L300.327 159.983C300.269 160.027 300.216 160.073 300.167 160.123C300.034 160.258 299.827 160.318 299.664 160.223L290.897 155.162C290.569 154.973 290.15 155.085 289.961 155.413C289.772 155.74 289.884 156.159 290.212 156.348L300.456 162.262C300.458 162.264 300.46 162.265 300.463 162.266L332.399 180.705C332.675 180.864 333.001 180.592 332.892 180.291L332.2 178.385Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.2 177.701C332.114 177.462 331.962 177.251 331.763 177.094L305.755 156.511C305.267 156.125 304.582 156.116 304.084 156.488L300.327 159.299C300.269 159.342 300.216 159.389 300.167 159.438C300.034 159.573 299.827 159.633 299.664 159.539L290.897 154.477C290.569 154.288 290.15 154.4 289.961 154.728C289.772 155.056 289.884 155.474 290.212 155.663L300.455 161.577C300.458 161.579 300.46 161.58 300.463 161.582L332.399 180.02C332.675 180.18 333.001 179.907 332.892 179.607L332.2 177.701Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.064 157.808C293.042 157.39 293.728 156.419 293.728 155.288C293.728 153.775 292.501 152.549 290.988 152.549C289.475 152.549 288.249 153.775 288.249 155.288C288.249 156.419 288.934 157.39 289.913 157.808L284.482 248.429H297.494L292.064 157.808Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.379 157.808C292.357 157.39 293.043 156.419 293.043 155.288C293.043 153.775 291.816 152.549 290.303 152.549C288.791 152.549 287.564 153.775 287.564 155.288C287.564 156.419 288.25 157.39 289.228 157.808L283.797 248.429H296.81L291.379 157.808Z",
    fill: "#8B8B8B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 122.429,
    width: 26.7138,
    height: 62.9968,
    rx: 13.3569,
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.2588,
    y: 147.946,
    width: 1.59486,
    height: 98.4823,
    rx: 0.797428,
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8384,
    y: 151.448,
    width: 1.59486,
    height: 13.443,
    rx: 0.797428,
    transform: "rotate(30 75.8384 151.448)",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.59486,
    height: 18.9128,
    rx: 0.797428,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 69.7009 172.919)",
    fill: "#8B8B8B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 70.4287,
    width: 38.1994,
    height: 90.0821,
    rx: 19.0997,
    fill: "#505050"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109.745,
    y: 106.917,
    width: 2.28056,
    height: 140.825,
    rx: 1.14028,
    fill: "#8B8B8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119.153,
    y: 111.925,
    width: 2.28056,
    height: 19.2228,
    rx: 1.14028,
    transform: "rotate(30 119.153 111.925)",
    fill: "#8B8B8B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.28056,
    height: 27.0444,
    rx: 1.14028,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 110.376 142.627)",
    fill: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.5 52.3609C137.5 52.4297 137.499 52.4984 137.497 52.5668C141.785 52.6733 145.229 56.1828 145.229 60.4965C145.229 64.8093 141.787 68.3183 137.5 68.4262V68.4287H137.304C137.302 68.4287 137.299 68.4287 137.297 68.4287C137.294 68.4287 137.291 68.4287 137.289 68.4287H121.636V68.4262C121.568 68.4279 121.5 68.4287 121.432 68.4287C117.051 68.4287 113.5 64.8773 113.5 60.4965C113.5 56.1157 117.051 52.5643 121.432 52.5643C121.501 52.5643 121.57 52.5652 121.638 52.5669C121.636 52.4985 121.636 52.4298 121.636 52.3609C121.636 47.9801 125.187 44.4287 129.568 44.4287C133.949 44.4287 137.5 47.9801 137.5 52.3609Z",
    fill: "#505050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.5 71.0728C271.5 71.0957 271.5 71.1186 271.499 71.1414C272.928 71.1769 274.076 72.3467 274.076 73.7846C274.076 75.2223 272.929 76.3919 271.5 76.4279V76.4287H271.435C271.434 76.4287 271.433 76.4287 271.432 76.4287C271.431 76.4287 271.43 76.4287 271.429 76.4287H266.212V76.4279C266.189 76.4284 266.167 76.4287 266.144 76.4287C264.684 76.4287 263.5 75.2449 263.5 73.7846C263.5 72.3244 264.684 71.1406 266.144 71.1406C266.167 71.1406 266.19 71.1409 266.213 71.1414C266.212 71.1186 266.212 71.0957 266.212 71.0728C266.212 69.6125 267.396 68.4287 268.856 68.4287C270.316 68.4287 271.5 69.6125 271.5 71.0728Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.7 22.2568C200.7 15.1721 206.443 9.42871 213.528 9.42871C218.786 9.42871 223.304 12.5915 225.286 17.1182C226.561 16.2163 228.117 15.6863 229.798 15.6863C233.752 15.6863 237.02 18.6196 237.546 22.4287H240.48C244.07 22.4287 246.98 25.3389 246.98 28.9287C246.98 32.5186 244.07 35.4287 240.48 35.4287H202C198.41 35.4287 195.5 32.5186 195.5 28.9287C195.5 25.7828 197.735 23.1589 200.703 22.558C200.701 22.4579 200.7 22.3575 200.7 22.2568Z",
    fill: "#505050"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.621 90.6616C159.621 87.7716 161.964 85.4287 164.854 85.4287C166.999 85.4287 168.842 86.7189 169.65 88.5655C170.17 88.1975 170.805 87.9813 171.491 87.9813C173.104 87.9813 174.437 89.1779 174.652 90.7317H175.848C177.313 90.7317 178.5 91.9189 178.5 93.3833C178.5 94.8476 177.313 96.0348 175.848 96.0348H160.152C158.687 96.0348 157.5 94.8476 157.5 93.3833C157.5 92.1 158.412 91.0296 159.623 90.7845C159.622 90.7437 159.621 90.7027 159.621 90.6616Z",
    fill: "#505050"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.882 28.139C317.625 28.445 317.457 28.8166 317.399 29.2122L309.818 80.8133C309.676 81.78 310.202 82.7212 311.1 83.1061L317.882 86.0127C317.987 86.0576 318.093 86.0935 318.198 86.1209C318.486 86.1954 318.731 86.43 318.731 86.7273V102.646C318.731 103.24 319.213 103.722 319.808 103.722C320.403 103.722 320.885 103.24 320.885 102.646V84.0477C320.885 84.0428 320.885 84.0379 320.885 84.033L320.885 26.0454C320.885 25.543 320.257 25.3143 319.934 25.6988L317.882 28.139Z",
    fill: "#505050"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.882 27.0618C317.625 27.3678 317.457 27.7394 317.399 28.135L309.818 79.7362C309.676 80.7029 310.202 81.6441 311.1 82.029L317.882 84.9355C317.987 84.9804 318.093 85.0163 318.198 85.0437C318.486 85.1183 318.731 85.3529 318.731 85.6501V101.568C318.731 102.163 319.213 102.645 319.808 102.645C320.403 102.645 320.885 102.163 320.885 101.568V82.9705C320.885 82.9656 320.885 82.9607 320.885 82.9558L320.885 24.9682C320.885 24.4658 320.257 24.2372 319.934 24.6217L317.882 27.0618Z",
    fill: "#8B8B8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.82 140.884C257.214 140.953 257.619 140.912 257.991 140.765L306.469 121.53C307.378 121.17 307.929 120.243 307.814 119.273L306.94 111.946C306.926 111.833 306.905 111.724 306.876 111.618C306.796 111.332 306.877 111.003 307.135 110.854L320.92 102.895C321.435 102.598 321.612 101.939 321.314 101.424C321.017 100.909 320.358 100.732 319.843 101.03L303.735 110.33C303.732 110.332 303.728 110.334 303.724 110.336L253.506 139.33C253.071 139.581 253.186 140.239 253.681 140.326L256.82 140.884Z",
    fill: "#505050"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.282 140.345C256.675 140.415 257.081 140.374 257.453 140.227L305.931 120.992C306.839 120.632 307.391 119.705 307.275 118.735L306.402 111.408C306.388 111.295 306.366 111.186 306.337 111.08C306.258 110.794 306.339 110.465 306.596 110.316L320.382 102.357C320.897 102.06 321.073 101.401 320.776 100.886C320.479 100.371 319.82 100.194 319.305 100.492L303.197 109.792C303.193 109.794 303.19 109.796 303.186 109.798L252.967 138.792C252.532 139.043 252.648 139.7 253.142 139.788L256.282 140.345Z",
    fill: "#8B8B8B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.689 138.287C385.553 137.911 385.315 137.58 385.001 137.332L344.104 104.966C343.338 104.359 342.26 104.345 341.477 104.93L335.569 109.35C335.478 109.418 335.394 109.492 335.317 109.57C335.109 109.782 334.783 109.876 334.526 109.728L320.74 101.769C320.225 101.471 319.567 101.648 319.269 102.163C318.972 102.678 319.148 103.336 319.663 103.634L335.77 112.933C335.774 112.935 335.778 112.938 335.782 112.94L386.001 141.934C386.436 142.185 386.948 141.756 386.776 141.284L385.689 138.287Z",
    fill: "#505050"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.689 137.21C385.553 136.834 385.315 136.504 385.001 136.255L344.104 103.889C343.338 103.283 342.26 103.268 341.477 103.853L335.569 108.274C335.478 108.342 335.394 108.415 335.317 108.493C335.109 108.705 334.783 108.8 334.526 108.651L320.74 100.692C320.225 100.394 319.567 100.571 319.269 101.086C318.972 101.601 319.148 102.26 319.663 102.557L335.77 111.856C335.774 111.859 335.778 111.861 335.782 111.863L386.001 140.857C386.436 141.108 386.948 140.68 386.776 140.207L385.689 137.21Z",
    fill: "#8B8B8B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.576 105.93C324.114 105.273 325.192 103.746 325.192 101.967C325.192 99.5883 323.264 97.6597 320.885 97.6597C318.506 97.6597 316.577 99.5883 316.577 101.967C316.577 103.746 317.655 105.273 319.193 105.93L310.654 248.429H331.115L322.576 105.93Z",
    fill: "#505050"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.499 105.93C323.037 105.273 324.115 103.746 324.115 101.967C324.115 99.5883 322.187 97.6597 319.808 97.6597C317.429 97.6597 315.5 99.5883 315.5 101.967C315.5 103.746 316.578 105.273 318.116 105.93L309.577 248.429H330.038L321.499 105.93Z",
    fill: "#8B8B8B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.205 197.429H108.372L122.387 241.157H88.1895L102.205 197.429Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.205 197.429H108.372L114.032 215.088H96.5448L102.205 197.429ZM94.9276 220.134L92.8612 226.581H117.715L115.649 220.134H94.9276ZM91.2441 231.626H119.332L122.387 241.157H88.1895L91.2441 231.626Z",
    fill: "#1573FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 241.157,
    width: 51.5765,
    height: 3.9243,
    fill: "#1573FE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1895 241.157L89.5371 236.952H121.039L122.387 241.157L88.1895 241.157Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_833_545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 197,
    width: 53,
    height: 49
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.205 197.429H108.372L114.032 215.088H96.5448L102.205 197.429ZM94.9276 220.134L92.8612 226.581H117.715L115.649 220.134H94.9276ZM91.2441 231.626H119.332L122.387 241.157H88.1895L91.2441 231.626Z",
    fill: "#2F63FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 241.157,
    width: 51.5765,
    height: 3.9243,
    fill: "#2F63FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1895 241.157L89.5371 236.952H121.039L122.387 241.157L88.1895 241.157Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_833_545)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.7726,
    cy: 186.777,
    r: 52.4174,
    fill: "white",
    fillOpacity: 0.1
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 246.429C0.5 245.324 1.39543 244.429 2.5 244.429H402.5C403.605 244.429 404.5 245.324 404.5 246.429C404.5 247.533 403.605 248.429 402.5 248.429H2.5C1.39543 248.429 0.5 247.533 0.5 246.429Z",
    fill: "#1573FE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.714,
    y: 110.429,
    width: 5.64286,
    height: 134,
    fill: "#1B2028"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 110.429,
    width: 8,
    height: 134,
    fill: "#1A2A42"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 256.643,
    y: 110.429,
    width: 5.64286,
    height: 134,
    fill: "#1B2028"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 251.5,
    y: 110.429,
    width: 8,
    height: 134,
    fill: "#1A2A42"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 121.429,
    width: 158,
    height: 22.5714,
    fill: "#1573FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.5 125.567V121.429H266.205L257.295 144H274.224L281.5 125.567ZM236.298 121.429H253.226L244.317 144H227.388L236.298 121.429ZM223.319 121.429H206.391L197.481 144H214.409L223.319 121.429ZM176.483 121.429H193.412L184.502 144H167.574L176.483 121.429ZM163.505 121.429H146.576L137.667 144H154.595L163.505 121.429ZM123.5 121.429H133.598L124.688 144H123.5V121.429Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.72 144L198.752 121.429H220.691L233.723 144H185.72Z",
    fill: "#1B2028"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 123.5,
    y: 121.429,
    width: 158,
    height: 2.39,
    fill: "#1B2028"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 162.429,
    width: 158,
    height: 22.5714,
    fill: "#1573FE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.5 166.567V162.429H266.205L257.295 185H274.224L281.5 166.567ZM236.298 162.429H253.226L244.317 185H227.388L236.298 162.429ZM223.319 162.429H206.391L197.481 185H214.409L223.319 162.429ZM176.483 162.429H193.412L184.502 185H167.574L176.483 162.429ZM163.505 162.429H146.576L137.667 185H154.595L163.505 162.429ZM123.5 162.429H133.598L124.688 185H123.5V162.429Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.517 162.429L248.564 169.438C251.726 174.914 247.773 181.761 241.449 181.761H175.994C169.67 181.761 165.717 174.914 168.879 169.438L172.926 162.429H244.517Z",
    fill: "#1B2028"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 123.5,
    y: 162.429,
    width: 158,
    height: 2.39,
    fill: "#1B2028"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.156 109.301C199.318 103.824 207.223 103.824 210.385 109.301L243.113 165.987C246.275 171.464 242.322 178.31 235.998 178.31H170.543C164.219 178.31 160.266 171.464 163.428 165.987L196.156 109.301Z",
    fill: "#1B2028"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M196.339 108.752C198.731 104.608 204.712 104.608 207.104 108.752L239.831 165.438C242.224 169.581 239.233 174.761 234.449 174.761H168.994C164.209 174.761 161.219 169.581 163.611 165.438L196.339 108.752Z",
    fill: "white",
    stroke: "#1573FE",
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M188.662 163.243H181.5V159.771L188.321 143.347H192.414V159.771H194.188V163.243H192.414V167.653H188.662V163.243ZM188.662 159.771V150.292H188.594L184.911 159.771H188.662Z",
    fill: "#1573FE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.466 168C199.624 168 198.214 167.468 197.237 166.403C196.259 165.338 195.77 163.833 195.77 161.889V149.111C195.77 147.167 196.259 145.662 197.237 144.597C198.214 143.532 199.624 143 201.466 143C203.308 143 204.717 143.532 205.695 144.597C206.673 145.662 207.162 147.167 207.162 149.111V161.889C207.162 163.833 206.673 165.338 205.695 166.403C204.717 167.468 203.308 168 201.466 168ZM201.466 164.528C202.762 164.528 203.41 163.729 203.41 162.132V148.868C203.41 147.271 202.762 146.472 201.466 146.472C200.17 146.472 199.522 147.271 199.522 148.868V162.132C199.522 163.729 200.17 164.528 201.466 164.528Z",
    fill: "#1573FE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.975 163.243H208.812V159.771L215.634 143.347H219.726V159.771H221.5V163.243H219.726V167.653H215.975V163.243ZM215.975 159.771V150.292H215.906L212.223 159.771H215.975Z",
    fill: "#1573FE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M201.332 128.903H203.022L203.542 118.815L203.62 115.721H200.734L200.812 118.815L201.332 128.903ZM202.19 135.299C203.1 135.299 203.854 134.649 203.854 133.609C203.854 132.569 203.1 131.867 202.19 131.867C201.254 131.867 200.5 132.569 200.5 133.609C200.5 134.649 201.254 135.299 202.19 135.299Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/Error404.c439c46a00f8beefbebd563dd7d2d31d.svg";
export { ForwardRef as ReactComponent };